import { apiFetch } from '@/lib/api';

export interface AdminUser {
  email: string;
  role: 'admin' | 'super_admin';
  display_name: string | null;
  created_at: string;
}

export const listAdminUsers = () => apiFetch<AdminUser[]>('/admin-users');

export const addAdminUser = (input: {
  email: string;
  role: 'admin' | 'super_admin';
  display_name?: string;
}) => apiFetch<AdminUser>('/admin-users', { method: 'POST', body: JSON.stringify(input) });

export const removeAdminUser = (email: string) =>
  apiFetch<{ status: 'deleted' }>(`/admin-users/${encodeURIComponent(email)}`, {
    method: 'DELETE',
  });
